import { makeAutoObservable, runInAction } from 'mobx';
import { IBlock, IBlockDetails, IBlockParams } from 'src/@types/Choqorak/Settings/Block';
import agent from 'src/api/agent';
export default class BlockStore {
  openDialog = false;

  BlockRegistry = new Map<number, IBlock>();

  editMode = false; //When click on edit button

  selectedBlock: IBlock | undefined = undefined;

  totalRecord: number = 0;

  selectedBlockDetail: IBlockDetails | undefined;

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  get BlockList() {
    return Array.from(this.BlockRegistry.values());
  }

  setBlockList = (Block: IBlock) => {
    this.BlockRegistry.set(Block.blockId!, Block);
  };

  //Pagination
  loadBlock = async (params: IBlockParams) => {
    // this.BlockRegistry.clear();
    try {
      const result = await agent.Block.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setBlockList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  BlockSearch = async (params: IBlockParams) => {
    this.BlockRegistry.clear();
    this.loadBlock(params);
  };

  getBlockFromRegistry = (id: number) => {
    let Block = this.BlockRegistry.get(id);
    if (Block) {
      this.editMode = true;
      this.selectedBlock = Block;
    }
  };

  clearSelectedBlock = () => {
    this.editMode = false;
    this.selectedBlock = undefined;
    this.selectedBlockDetail = undefined;
  };

  deleteBlock = async (id: number, remark?: string) => {
    try {
      await agent.Block.delete(id, remark!);
      runInAction(() => {
        this.BlockRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    } catch (error) {
      console.log(error);
    }
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createBlock = async (Block: IBlock) => {
    await agent.Block.create(Block);
    runInAction(() => {
      this.loadBlock({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedBlock();
    });
  };

  updateBlock = async (Block: IBlock) => {
    await agent.Block.update(Block);

    runInAction(() => {
      this.loadBlock({ pageIndex: 0, pageSize: 5 });
      this.BlockRegistry.delete(Block.blockId!);
      this.BlockRegistry.set(Block.blockId!, Block);
      this.clearSelectedBlock();
    });
  };

  loadBlockDetail = async (id: number = this.ID) => {
    try {
      const getBlockDetail = await agent.Block.getDetail(id);
      runInAction(() => {
        this.selectedBlockDetail = getBlockDetail;
      });
    } catch (error) {}
  };
}
